import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useEffect, useState } from "react";
export var VersionContext = /*#__PURE__*/ createContext({
    commit: null,
    version: null
});
var VersionContextWrapper = function(param) {
    var children = param.children;
    var ref = useState(null), version = ref[0], setVersion = ref[1];
    var ref1 = useState(null), commit = ref1[0], setCommit = ref1[1];
    useEffect(function() {
        if (version && commit) {
            return;
        }
        (function() {
            return __awaiter(void 0, void 0, void 0, function() {
                var response, ref, version, commit, _a;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetch("/version")
                            ];
                        case 1:
                            response = _state.sent();
                            if (response.status !== 200) {
                                return [
                                    2
                                ];
                            }
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            ref = _state.sent(), version = ref.version, commit = ref.commit;
                            setVersion(version);
                            setCommit(commit);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            _a = _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
        })();
    }, []);
    return /*#__PURE__*/ React.createElement(VersionContext.Provider, {
        value: {
            commit: commit,
            version: version
        }
    }, children);
};
export default VersionContextWrapper;
